{
  "de": {
    "collections": {
      "headings": {
        "courses": "Passende Fortbildungen",
        "gradeLevels": "Klassenstufen",
        "materials": "Materialien",
        "schoolTypes": "Schulformen",
        "subjectTypes": "Schulfächer"
      },
      "howTo": {
        "header": {
          "heading": "Die Kollektionen - entdecke fertige Unterrichtsmaterialien",
          "link": "Alle Kollektionen entdecken",
          "list_html": "<li><i class='bi bi-check-lg'></i>Kollektionen sind kuratierte Sammlungen von Unterrichtsmaterialien zu bestimmten Themen und für bestimmte Zielgruppen.</li><li><i class='bi bi-check-lg'></i>Finde vollständige Unterrichtsentwürfe mit allen Materialien, oder picke dir einzelne Elemente heraus und adaptiere sie für deine Zwecke.</li><li><i class='bi bi-check-lg'></i>Per Remix-Button erstellst du im Handumdrehen eine eigene Kopie in deiner eigenen Ablage und kannst sie direkt im Unterricht einsetzen.</li>"
        },
        "recommendations": {
          "heading": "Entdecke aktuelle Kollektionen"
        },
        "tile": {
          "collectionTitle": "Vertretungsstunden zum bewegten Lernen",
          "help": {
            "author_partner": "Autor*in oder Partner",
            "title": "Thema der Kollektion"
          },
          "staticAlt": "Kinder, die in der Natur Ball spielen"
        },
        "title": "Alles Wissenswerte über Kollektionen"
      },
      "labels": {
        "fobizzTeam": "Das fobizz Team"
      },
      "links": {
        "breadCrumbIndex": "Unterrichtsmaterial",
        "email": "E-Mail",
        "learnMore": "Mehr erfahren"
      },
      "modelName": "Kollektion",
      "correctionAssistantHint": "KI kann Lehrkräfte bei der Analyse von Schülerarbeiten und bei der Formulierung von Feedback unterstützen. Die generierten Inhalte sind Vorschläge, die immer überprüft werden müssen. Die pädagogische Bewertung erfolgt immer durch die Lehrkraft. Weitere Infos findest du <a href='https://app.fobizz.com/website/public_pages/63f40923-707c-4c29-a3fb-24190cbaccd4?public_token=5661a251e6152bb6cc51ff14facde3d4&back_url=https%3A%2F%2Fapp.fobizz.com%2Fcollections%2Fb7294bbe-a1df-4a10-9031-89fc64cd1766&back_title=Vorlagen%20f%C3%BCr%20Korrekturhilfe%20und%20SuS-Feedback%20Assistenten' target='_blank'>hier</a>.",
      "searchPlaceholder": "Material suchen",
      "share": {
        "email": {
          "body": "In der fobizz Galerie habe ich \"{name}\" gefunden und möchte es mit dir teilen. Mit dem folgenden Link kannst du darauf zugreifen: {shareUrl}"
        }
      }
    }
  }
}
